export enum AppointmentStatus {
  declined = 'declined',
  accepted = 'accepted',
  requested = 'requested',
  acceptedWithMessage = 'acceptedWithMessage',
  cancelled = 'cancelled',
}
